
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class VoucherMasterDialog extends _Ext.DialogBase<VoucherMasterRow, any> {
        protected getFormKey() { return VoucherMasterForm.formKey; }
        protected getIdProperty() { return VoucherMasterRow.idProperty; }
        protected getLocalTextPrefix() { return VoucherMasterRow.localTextPrefix; }
        protected getNameProperty() { return VoucherMasterRow.nameProperty; }
        protected getService() { return VoucherMasterService.baseUrl; }
        protected getDeletePermission() { return VoucherMasterRow.deletePermission; }
        protected getInsertPermission() { return VoucherMasterRow.insertPermission; }
        protected getUpdatePermission() { return VoucherMasterRow.updatePermission; }

        protected get_ExtDialogOptions() {
            let options = super.get_ExtDialogOptions();
            options.ShowDeleteButton = false;
            options.AutoFitContentArea = false;
            return options;
        }
        protected form = new VoucherMasterForm(this.idPrefix);
        public newformat = "";

        public string1 = ""; string2 = ""; string3 = ""; string4 = ""; string5 = ""; string6 = ""; separator = "";

        constructor() {
            super();
            q.hideEditorLabel(this.form.Details);
            this.form.VoucherCode.changeSelect2(e => {
                this.form.Prefix.value = this.form.VoucherCode.value;
                var x = this.generatenewformat(this.form.Prefix.value, 3);
                this.form.Format.value = x;
            });
            this.form.CounterWise.changeSelect2(e => {
                if (this.form.CounterWise.value == true) {
                    var x = this.generatenewformat("COUNTER", 2);
                    this.form.Format.value = x;
                } else {
                    var x = this.generatenewformat("", 2);
                    this.form.Format.value = x;
                }
            });
            this.form.BranchWise.changeSelect2(e => {
                if (this.form.BranchWise.value == true) {
                    var x = this.generatenewformat("BRANCH", 1);
                    this.form.Format.value = x;
                } else {
                    var x = this.generatenewformat("", 1);
                    this.form.Format.value = x;
                }
            });
            //this.form.Prefix.changeSelect2(e => {
            //    var x = this.generatenewformat(this.form.Prefix.value, 3);
            //    this.form.Format.value = x;
            //});
            this.form.PrefixDate.changeSelect2(e => {
                var x = this.generatenewformat(this.form.PrefixDate.value, 4);
                this.form.Format.value = x;
            });
            this.form.Suffix.changeSelect2(e => {
                var x = this.generatenewformat(this.form.Suffix.value, 5);
                this.form.Format.value = x;
            });
            this.form.LastNumber.changeSelect2(e => {
                var x = this.generatenewformat(this.form.LastNumber.value, 6);
                this.form.Format.value = x;
            });
            this.form.Separator.changeSelect2(e => {
                var x = this.generatenewformat(this.form.Separator.value, 7);
                //alert(x);
                this.form.Format.value = x;
            });
            this.form.PrefillwithZero.changeSelect2(e => {
                if (this.form.PrefillwithZero.value == true) {
                    Serenity.EditorUtils.setReadonly(this.form.Noofzeroes.element, false);
                } else {
                    Serenity.EditorUtils.setReadonly(this.form.Noofzeroes.element, true);
                }

            });


        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.VoucherCode.value != "") {
                if (this.form.Separator.value == "") {
                    this.form.Separator.value = "-"
                }
            } else {
                if (this.form.Separator.value == "") {
                    this.form.Separator.value = "-"
                }
            }
            this.newformat = this.form.Format.value;
            this.separator = this.form.Separator.value;
            if (this.form.BranchWise.value == true) {
                this.string1 = "[BRANCH]";
                if (this.form.CounterWise.value == true) {
                    this.string1 = "[BRANCH]" + this.separator;
                }
            }
            if (this.form.CounterWise.value == true) {
                this.string2 = "[COUNTER]";
                if (this.form.Prefix.value != "") {
                    this.string2 = "[COUNTER]" + this.separator;
                }
            }
            if (this.form.Prefix.value != "") {
                this.string3 = "[" + this.form.Prefix.value + "]" + this.separator;
            }
            if (this.form.PrefixDate.value != "") {
                this.string4 = this.form.PrefixDate.value;
                if (this.form.Suffix.value != "") {
                    this.string4 = this.form.PrefixDate.value + this.separator;
                }
            }
            if (this.form.Suffix.value != "") {
                this.string5 = "[" + this.form.Suffix.value + "]";
                if (this.form.LastNumber.value.toString() != "") {
                    this.string5 = "[" + this.form.Suffix.value + "]" + this.separator;
                }
            }
            if (this.form.LastNumber.value != parseInt("") && this.form.LastNumber.value != null) {
                this.string6 = "[" + this.form.LastNumber.value.toString() + "]";
            }
            this.separator = this.form.Separator.value;

            var fieldEditor: JQuery = this.form.LedgerId.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );
        }

        protected inplaceSearchClick(e: any): void {
            if (!this.isViewMode()) {
                var grid = OMS.AccountLedgerGrid;
                var pickerDialog = new _Ext.GridItemPickerDialog({
                    gridType: grid, multiple: false, title: "Select Ledeger", Width: 500,
                });

                pickerDialog.onSuccess = (selectedItems: OMS.AccountLedgerRow[]) => {

                    if (selectedItems.length > 0) {

                        this.form.LedgerId.value = selectedItems[0].LedgerId.toString();
                    }
                }
                pickerDialog.dialogOpen();

            }
            else {
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
            }
        }


        private generatenewformat(value, position) {
            this.separator = this.form.Separator.value;
            switch (position) {
                case 1:
                    if (value != "") {
                        this.string1 = "[" + value + "]" + this.separator;
                    } else
                        this.string1 = ""
                    break;
                case 2:
                    if (value != "") {
                        this.string2 = "[" + value + "]" + this.separator;
                    } else
                        this.string2 = ""
                    break;
                case 3:
                    if (value != "") {
                        this.string3 = "[" + value + "]" + this.separator;
                    } else
                        this.string3 = ""
                    break;
                case 4:
                    if (value != "") {
                        this.string4 = value + this.separator;
                    } else
                        this.string4 = ""
                    break;
                case 5:
                    if (value != "") {
                        this.string5 = "[" + value + "]" + this.separator;
                    } else
                        this.string5 = ""
                    break;
                case 6:
                    if (value != "") {
                        this.string6 = "[" + value + "]";
                    } else
                        this.string6 = ""
                    break;
                case 7:
                    if (this.separator == "/") {
                        let re = /\-/gi;
                        this.newformat = this.newformat.replace(re, "/");
                    } else if (this.separator == "-") {
                        //alert(this.string4);
                        if (this.string4 == "[MM]/[YY]" + this.separator || this.string4 == "[MM]/[YY]") {
                            this.newformat = this.newformat.replace("M]/[Y", "M]_[Y");
                        }
                        else if (this.string4 == "[MON]/[YYYY]" || this.string4 == "[MON]/[YYYY]" + this.separator) {
                            this.newformat = this.newformat.replace("N]/[Y", "N]_[Y");
                        }
                        let re = /\//gi;
                        this.newformat = this.newformat.replace(re, "-");
                        this.newformat = this.newformat.replace("]_[", "/");
                    }
                    break;


            }
            if (position != 7) {
                this.newformat = this.string1 + this.string2 + this.string3 + this.string4 + this.string5 + this.string6;
            }
            return this.newformat;
        }

    }
}